import { Entity } from './Entity';

export class Player implements Entity {
  public x: number = 0;
  public y: number = 0;
  public width: number = 498 / 1.8;
  public height: number = 91 / 1.8;
  public speed: number = 600;
  public resource = {
    url: 'player',
    width: 498,
    height: 91,
  };

  constructor() {
    this.y = window.innerHeight - this.height;
    this.x = window.innerWidth / 2 - this.width / 2;
  }

  get position(): Entity['position'] {
    return [this.x, this.y];
  }

  get size(): Entity['size'] {
    return [this.width, this.height];
  }

  move(dt: number, toXPosition: number | null = null) {
    this.x += this.speed * dt;
    const maxDiff = Math.abs(this.speed * dt);
    const diff = Math.abs(this.x - (toXPosition || 0));

    if (toXPosition !== null && diff <= maxDiff) {
      this.x = toXPosition;
    }

    return this.position;
  }
}
